import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
    uri: 'https://awaited-jawfish-77.hasura.app/v1/graphql',
    headers: {
        'x-hasura-admin-secret':
          '5Ane291GXzoO9deJ4RtRdJRXi0UnveXFJtHOnX9HN1qpdtnkEITIh5k2H9ejM7HD',
      },
      cache: new InMemoryCache(),
});

export default client;